import { ColDef } from "ag-grid-community";
import {
  FilterCriteria,
  GridDataRequest,
  GridDataResponse,
} from "patients-experience-client";
import { createPatientApi } from "../../../api-helpers/PatientApiHelper";
import { GenericGrid } from "../../../grid/GenericGrid";
import { BooleanIconRenderer } from "../../../grid/renderers/BooleanIconRenderer";
import { formatDateTimeToLocal } from "../../schedule/dateFormat";

export interface Props {
  patientId?: string;
}

export const ActivityGrid = ({ patientId }: Props) => {
  const patientsApi = createPatientApi();

  const colDefs: ColDef[] = [
    {
      field: "eventDate",
      headerName: "Date",
      sortable: true,
      valueFormatter: (params) => formatDateTimeToLocal(params.data.eventDate),
      minWidth: 120,
      sort: "desc",
    },
    {
      field: "eventTypeName",
      headerName: "Event Category",
      minWidth: 140,
      sortable: true,
    },
    {
      field: "eventSubtypeName",
      headerName: "Event Type",
      minWidth: 140,
      sortable: true,
    },
    {
      field: "postEnrollmentEngagement",
      headerName: "Interactive Event",
      sortable: true,
      minWidth: 180,
      cellRenderer: BooleanIconRenderer,
    },
    {
      field: "notes",
      headerName: "Notes",
      sortable: true,
    },
  ];

  const loadData = async (
    request: GridDataRequest,
  ): Promise<GridDataResponse> => {
    const response =
      await patientsApi.patientsControllerGetPatientActivityEvents(request);

    return response.data;
  };

  return (
    <div className="d-flex px-3 px-md-4 px-lg-5 d-flex align-items-stretch">
      <div className="flex-fill">
        <div className="py-4">
          <GenericGrid
            colDefs={colDefs}
            dataProvider={loadData}
            filters={[
              {
                propertyName: "patientId",
                operator: "equals",
                propertyValue: patientId,
              },
            ]}
            gridId="activity-grid"
          ></GenericGrid>
        </div>
      </div>
    </div>
  );
};
